export enum NotificationEvents {
  CHANGE_BOOKING = 'CHANGE_BOOKING',
}
